import React, { ForwardRefRenderFunction, forwardRef } from 'react';
import { Input as AInput } from '@firesoon/antd';
import { FSInputProps } from './interface';
import classnames from 'classnames';

const Input: ForwardRefRenderFunction<AInput, FSInputProps> = (props, ref) => {
  const { className, allowClear = true, suffix, ...rest } = props;

  return (
    <AInput
      placeholder="请输入内容"
      className={classnames('fs-input', className, {
        'fs-input-clear': allowClear && suffix,
        'fs-input-not-disabled': !rest?.disabled,
      })}
      ref={ref}
      allowClear={allowClear}
      suffix={suffix}
      {...rest}
    />
  );
};

export default forwardRef(Input);
